import { LegalLayout } from './LegalLayout';

const SUPPORT_EMAIL = 'support@radiologylive.ai';
const LAST_UPDATED = '2026-02-26';

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy">
      <p className="text-sm text-muted-foreground">Last updated: {LAST_UPDATED}</p>

      <p>
        This Privacy Policy explains how Radiologylive.ai, LLC (&quot;RadiologyLive.ai&quot;, &quot;we&quot;, &quot;us&quot;) collects,
        uses, and shares information when you use the Services.
      </p>

      <h2>1. Data minimization</h2>
      <p>
        RadiologyLive.ai is designed to minimize sensitive data. Unless and until RadiologyLive.ai explicitly
        enables a HIPAA/BAA-backed workflow, you must not submit patient identifiers or PHI to the
        Services.
      </p>

      <h2>2. Information we collect</h2>
      <ul>
        <li><strong>Account data</strong> (e.g., email, authentication identifiers, onboarding info you provide).</li>
        <li><strong>Operational usage data</strong> (feature usage events, performance metrics, error diagnostics).</li>
        <li><strong>Security/audit data</strong> (login events, account actions, and related metadata).</li>
        <li><strong>Billing metadata</strong> (subscription state from our payment provider; not full card numbers).</li>
      </ul>

      <h2>3. How we use information</h2>
      <ul>
        <li>Operate and secure the Services.</li>
        <li>Troubleshoot, improve reliability, and provide support.</li>
        <li>Comply with legal obligations and enforce policies.</li>
      </ul>

      <h2>4. How we share information</h2>
      <p>
        We may share information with service providers who help us run the Services (hosting,
        analytics, logging, email, payments), subject to contractual obligations appropriate to their
        role, and with legal authorities when required.
      </p>

      <h2>5. Security</h2>
      <p>
        We implement administrative, technical, and physical safeguards designed to protect
        information. No system is 100% secure; you are responsible for maintaining secure access to
        your account and devices.
      </p>

      <h2>6. Contact</h2>
      <p>
        Privacy questions: <a className="text-primary hover:underline" href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
      </p>

      <p className="text-xs text-muted-foreground">
        Note: This is a high-quality draft intended for beta. Have counsel review before broad
        commercial launch.
      </p>
    </LegalLayout>
  );
}
